const colorNames = {
  accentBlue: '--color-accent-blue',
  oldBlue: '--color-old-blue',
  blue: '--color-blue',
  bluePurple: '--color-blue-purple',
  body: '--color-body',
  danger: '--color-danger',
  gray: '--color-gray',
  gray9: '--color-gray-9',
  grayLight: '--color-gray-light',
  grayLighter: '--color-gray-lighter',
  darkGray: '--color-dark-gray',
  green: '--color-green',
  green5: '--color-green-5',
  green6: '--color-green-6',
  green7: '--color-green-7',
  greenLighter: '--color-green-lighter',
  lightBlue: '--color-light-blue',
  orange: '--color-calendula-gold-5',
  orangeDarker: '--color-calendula-gold-6',
  orangeLighter: '--color-calendula-gold-1',
  palePurple: '--color-pale-purple',
  palePurpleLight: '--color-pale-purple-light',
  red: '--color-red',
  redLight: '--color-red-light',
  rose: '--color-rose',
  skyBlue: '--color-sky-blue',
  instachampPurple: '--color-instachamp-purple',
};

const colorsBase = Object.create(null);
Object.assign(colorsBase, colorNames);

const layerNames = {
  layerMax: '--layer-max',
};

const layerBase = Object.create(null);
Object.assign(layerBase, layerNames);

const handler = {
  get: (target: object, prop: string) => {
    if (!Reflect.has(target, prop)) return '';
    return getComputedStyle(document.body).getPropertyValue(
      Reflect.get(target, prop),
    );
  },
  set: () => false,
};

const propertyFactory = <T extends string | number | symbol>(
  base,
): Record<T, string> => {
  return new Proxy(base, handler);
};

export const colors = propertyFactory<keyof typeof colorNames>(colorsBase);

export const layers = propertyFactory<keyof typeof layerNames>(layerBase);

export type ColorType = 'neutral' | 'info' | 'warning' | 'error' | 'success';

// [backgroundColor, contentColor, borderColor]
const getColorsByType = (type: ColorType = 'info') => {
  const colorsPerType: Record<ColorType, string[]> = {
    neutral: [colors.grayLighter, colors.palePurple, colors.palePurpleLight],
    info: [colors.lightBlue, colors.blue, colors.blue],
    warning: [colors.orangeLighter, colors.orangeDarker, colors.orange],
    success: [colors.greenLighter, colors.green, colors.green],
    error: [colors.rose, colors.red, colors.redLight],
  };
  return colorsPerType[type];
};

export const getColorStylesByType = (type: ColorType = 'info') => {
  const [backgroundColor, color, borderColor] = getColorsByType(type);
  return { backgroundColor, borderColor, color };
};
